<div class="ppLogin_content">
  <div class="ppLogin_body">
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="resetPassword()">
      <div class="loginBody-content">
          <h1 class="loginTitle">
              {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
          </h1>
          <h2 class="loginHeader">
              {{ 'MODULES.LOGIN.FORGOT_PASSWORD_SUBHEADER' | transloco }}
          </h2>

          <h5 class="loginHeader forgot-password-info">
              {{ 'MODULES.LOGIN.FORGOT_PASSWORD_MESSAGE' | transloco }}
          </h5>
          <div class="dsFieldWrap dsFieldError">
            <div class="dsLabel">{{ 'MODULES.LOGIN.EMAIL' | transloco }}<sup class="dsAsterix">*</sup></div>
            <mat-form-field appearance="outline" floatLabel="never">
              <input matInput type="text" required maxlength="100" formControlName="email"/>
            </mat-form-field>
            <div class="dsErrorMsg" *ngIf="forgotPasswordForm.get('email').invalid && (forgotPasswordForm.get('email').touched || forgotPasswordForm.get('email').dirty)">
              <ng-container *ngIf="forgotPasswordForm.get('email').hasError('required')">
                {{ 'MODULES.WIN_LOSS.MESSAGES.EMAIL_EMPTY_ERROR' | transloco }}
              </ng-container>
              <ng-container *ngIf="forgotPasswordForm.get('email').hasError('invalidFormat')">
                {{ 'MODULES.LOGIN.LOGIN_FROM_EMAIL' | transloco }}
              </ng-container>
            </div>
          </div>
      </div>
      <footer class="loginBody-footer">
          <button type="submit" class="loginAction_btn">
            {{ 'MODULES.LOGIN.SUBMIT' | transloco }}
          </button>
          <div class="login-options">
              <div class="login-options-link">
                  <span>{{ 'MODULES.LOGIN.ALREADY_HAVE_LOGIN_AND_PASSWORD' | transloco }}</span>
                  <a class="dsLink" (click)="goToSignIn()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_IN' | transloco }}</span></a>
              </div>
          </div>
        </footer>
      </form>
    </div>
    <div class="login-copyright">
      {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
    </div>
</div>
